import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CookieService } from './cookie.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  langSubject: BehaviorSubject<string> = new BehaviorSubject('pl');

  constructor(private cookieService: CookieService) {
    const language = cookieService.findCookieValue('LANGUAGE');
    if (language === 'pl' || language === 'en') {
      this.langSubject.next(language);
    }
  }

  switchLanguage(lang: string) {

    if (lang === 'pl' || lang === 'en') {
      this.langSubject.next(lang);
      if (this.cookieService.findCookieValue('ALLOW_COOKIES') !== false) {
        this.cookieService.setCookieValue('LANGUAGE', lang, 360);
      }
    }
    else { throw new Error('incorrect lang parameter'); }
  }

  languageObs() {
    return this.langSubject.asObservable();
  }

}
